import { FormControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { NoteProfile } from 'src/app/services/API.service';
import { DropdownEntryForm } from './dropdownentry-form';

export class NoteForm {
    DropTitle = new FormControl();
    NotesTitle = new FormControl();
    DropDownEntries: FormArray = new FormArray([]);

    constructor(note: NoteProfile, private fb: FormBuilder) {

        if (note) {
            this.DropTitle.setValue(note.DropTitle);
            this.NotesTitle.setValue(note.NotesTitle);
    
            note.DropDownEntries.forEach(n => {
                this.DropDownEntries.push(this.fb.group(new DropdownEntryForm(n)));
            });
            
            this.DropTitle.setValidators([Validators.required]);
            this.NotesTitle.setValidators([Validators.required]);
        }
    }
}